module.exports = __webpack_public_path__ + "static/img/crediline.a57a1bc4.png";